import { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { ISSUE_STATUS, SELECTION_ALL } from '../../common/constants';
import { useTranslation } from 'react-i18next';

const IssueStatusDropdown = ({ statusValue, onChange }) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(statusValue ?? SELECTION_ALL);

  const toggle = () => setDropdownOpen(prev => !prev);

  const handleSelect = (value) => {
    setSelectedStatus(value);
    if (onChange) {
      onChange(value);
    }
  };

  useEffect(() => {
    setSelectedStatus(statusValue ?? SELECTION_ALL);
  }, [statusValue]);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary" className="mb-2 me-2 ms-2">
        {selectedStatus === SELECTION_ALL
          ? t('PageAdmin.SelectAllStatuses')
          : t(`PageAdmin.DeviceIssueStatus.${selectedStatus}`)}
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem
          key={SELECTION_ALL}
          onClick={() => handleSelect(SELECTION_ALL)}
          active={selectedStatus === SELECTION_ALL}
        >
          {t('PageAdmin.SelectAllStatuses')}
        </DropdownItem>
        {Object.values(ISSUE_STATUS).map((status) => (
          <DropdownItem
            key={status}
            onClick={() => handleSelect(status)}
            active={selectedStatus === status}
          >
            {t(`PageAdmin.DeviceIssueStatus.${status}`)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default IssueStatusDropdown;
